import AContainer from '../../library/ExtendedObjects/AContainer.js';
import Utils from '../../library/Misc/Utils.js';

export default class DragTools extends AContainer 
{
    constructor(scene, dragger, parentCont, outlineColor)
    {
        super(scene);

        this.scene = scene;
        this.dragger = dragger;
        this.pCont = parentCont;
        this.color = outlineColor;

        this.minScale = .25;
        this.maxScale = 1;
        this.btnHalfHeight = 22;

        this.scene.addToParent(this, this.pCont);
        this.setPosition(this.dragger.x, this.dragger.y);

        this.createTools();
        this.tweenInTools();
    }

    createTools()
    {
        this.initScaleW = {width:40, height:41, x:0, y:-this.dragger.height/2 - this.btnHalfHeight*2 - 10, scale:2};
        this.initRotateW = {width:45, height:45, x:this.dragger.width/2 + this.btnHalfHeight + 35, y:0, scale:2};
        this.scaleBtn = this.scene.addImage(this.initScaleW.x, this.initScaleW.y, "Btn_Scale");
        this.rotateBtn = this.scene.addImage(this.dragger.width/2 + this.btnHalfHeight + 35, 0, "Btn_Rotate");

        this.outline = this.scene.add.graphics();
        this.outline.lineStyle(1, this.color, 1);
        this.outline.strokeRect(-this.dragger.width/2, -this.dragger.height/2, this.dragger.width, this.dragger.height);

        this.outline.beginPath();
        this.outline.moveTo(this.scaleBtn.x, this.scaleBtn.y);
        this.outline.lineTo(this.scaleBtn.x, -this.dragger.height/2);
        this.outline.closePath();
        this.outline.strokePath();

        this.outline.beginPath();
        this.outline.moveTo(this.rotateBtn.x, this.rotateBtn.y);
        this.outline.lineTo(this.dragger.width/2, this.rotateBtn.y);
        this.outline.closePath();
        this.outline.strokePath();

        this.addDragFunctions(this.scaleBtn);
        this.addDragFunctions(this.rotateBtn);

        this.add(this.outline);
        this.add(this.scaleBtn);
        this.add(this.rotateBtn);

        this.toggleBtns(false);
        this.setScale(0, 0);
        this.scaleBtn.setScale(this.initScaleW.scale, this.initScaleW.scale);
        this.rotateBtn.setScale(this.initRotateW.scale, this.initRotateW.scale);
        this.angle = this.dragger.angle;
    }

    toggleBtns(onOff)
    {
        if(this.scene){
            if(onOff){
                this.scaleBtn.setInteractive();
                this.rotateBtn.setInteractive();
                this.scene.input.setDraggable(this.scaleBtn);
                this.scene.input.setDraggable(this.rotateBtn);
            } else {
                this.scaleBtn.disableInteractive();
                this.rotateBtn.disableInteractive();
                if(this.scene.input._draggable.includes(this.scaleBtn)) this.scene.input.setDraggable(this.scaleBtn, false);
                if(this.scene.input._draggable.includes(this.rotateBtn)) this.scene.input.setDraggable(this.rotateBtn, false);
            }
        }
    }

    tweenInTools()
    {
        let btnScale = 1/this.dragger.baseScale;

        this.scaleBtn.setScale(btnScale);
        this.rotateBtn.setScale(btnScale);
        
        this.scene.killTween(this);
        this.scene.addTween(this, 300, {scaleX:this.dragger.baseScale, scaleY:this.dragger.baseScale}, Phaser.Math.Easing.Back.Out,
            ()=>{this.toggleBtns(true);});
    }

    tweenOutTools()
    {
        this.toggleBtns(false);
        this.scene.addTween(this, 300, {scaleX:0, scaleY:0}, Phaser.Math.Easing.Back.In);
    }

    addDragFunctions(btn)
    {
        let prevDist;
        btn.on('dragstart', (pointer)=>{
            prevDist = Phaser.Math.Distance.Between(Utils.StagePos(this).x, Utils.StagePos(this).y, pointer.x, pointer.y);
        });
        btn.on('drag', (pointer)=>{
            if(btn === this.rotateBtn){
                var targetAngle = (360 / (2 * Math.PI)) * Phaser.Math.Angle.Between(this.x, this.y, pointer.x, pointer.y);
          
                if(targetAngle < 0) targetAngle += 360;

                this.angle = targetAngle;
                this.dragger.angle = targetAngle;
            }
            else if(btn === this.scaleBtn){
                let distToCenter = Phaser.Math.Distance.Between(Utils.StagePos(this).x, Utils.StagePos(this).y, pointer.x, pointer.y);
                let deltaDist = Phaser.Math.Clamp((distToCenter / prevDist)*this.dragger.baseScale, this.minScale, this.maxScale);
                let btnDelta = 1/deltaDist;

                this.setScale(deltaDist, deltaDist);
                this.dragger.setScale(deltaDist, deltaDist);

                this.scaleBtn.setScale(btnDelta, btnDelta);
                this.rotateBtn.setScale(btnDelta, btnDelta);

                //console.log(this.scaleBtn.y, this.dragger.getTopCenter());
                // this.scaleBtn.setPosition(0, this.dragger.getTopCenter().y - this.btnHalfHeight*2);
                //this.updateBtns(this.scaleBtn, this.rotateBtn);
            }
        });
        
        btn.on('dragend', ()=>{
            this.dragger.baseScale = this.scaleX;
            this.initScaleW.x = this.scaleBtn.x;
            this.initScaleW.y = this.scaleBtn.y;
            this.initRotateW.x = this.rotateBtn.x;
            this.initRotateW.y = this.rotateBtn.y;
        });
    }

    updateBtns(btn1, btn2)
    {
        btn1.setPosition(0, this.dragger.getTopCenter() - 50 + this.scene.maskAdj.y);
        btn2.setPosition(this.dragger.getRightCenter() + 50, 0);
    }

    cleanUp()
    {
        this.toggleBtns(false);

        this.rotateBtn.destroy();
        this.scaleBtn.destroy();
        this.outline.destroy();
    }
}